import { Clickable } from '@carvana/vdp-components';
import { SyntheticEvent } from 'react';
import { useTileDataContext } from '~/contexts/TileDataContext';
import FavoriteIcon from './FavoriteIcon';
import withHandleFavorite from './withHandleFavorite';

interface OwnProps {
  handleFavorite: () => void;
}

const FavoriteVehicleComponent = ({ handleFavorite }: OwnProps) => {
  const { tileData } = useTileDataContext();

  const submitFavorite = () => {
    if (!tileData?.stockNumber) {
      return;
    }

    handleFavorite();
  };

  const handleOnClick = (event: SyntheticEvent) => {
    event.preventDefault();
    submitFavorite();
  };

  return (
    <Clickable
      className="absolute flex h-44 items-center justify-center pointer-events-auto right-[1px] top-[-2px] w-44"
      data-analytics-id="favorite-vehicle"
      data-qa="favorite-vehicle"
      onClick={handleOnClick}
    >
      <FavoriteIcon isFavorite={tileData?.isFavorite ?? false} />
    </Clickable>
  );
};

export default withHandleFavorite(FavoriteVehicleComponent);
